const styles = theme => ({
  root: {

  },

  closeButton : {
    cursor : "pointer"
  },

  textArea : {
    width : "100%"
  },

  cardButtonBlock : {
    textAlign : "right",
    paddingTop: 5
  },

  exerciseGeneral : theme.showHtmlText,
});

export default styles;